import React, { useMemo } from 'react';
import t from '@rcm/i18n-client';

interface Props {
    error?: { data: { messages: Array<{ primary: boolean; value: string }>} }
}

const Errors = (props: Props) => {
    const err = useMemo(
        () => (
            props.error?.data?.messages?.find((msg) => msg.primary)?.value ??
            t("An error occurred. Please try again. For further assistance, please call Reliv's Distributor Services Center at 1-800-RELIV US (735.4887).")
        ),
        [props.error?.data?.messages]
    );

    return <p>{err}</p>;
}

export default Errors;
